import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams, useHistory } from 'react-router-dom';
import Button from '../../components/Button';
import { FaArrowLeft } from 'react-icons/fa';
import './UserChangeDetail.scss';

const UserChangeDetail = ({ store }) => {
    const { change_id } = useParams();
    const history = useHistory();

    useEffect(() => {
        store.getUserChange(change_id);
        return () => {
            store.clearUserChange();
        };
    }, [store, change_id]);

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleString('de-DE');
    };

    const change = store.currentUserChange;

    if (!change) return null;

    const renderField = (label, oldValue, newValue) => {
        if (oldValue === newValue) return null;
        if (newValue === null && oldValue === null) return null;

        return (
            <div className="detail-field">
                <div className="detail-field-label">{label}</div>
                <div className="detail-field-values">
                    <span className="old-value">{oldValue || '-'}</span>
                    <span className="arrow">→</span>
                    <span className="new-value">{newValue || '-'}</span>
                </div>
            </div>
        );
    };

    return (
        <div className="UserChangeDetail">
            <div className="detail-header">
                <Button onClick={() => history.goBack()} title="Back">
                    <FaArrowLeft />
                </Button>
                <h2>User Change Details</h2>
            </div>

            <div className="detail-section">
                <h3>General Information</h3>
                <div className="detail-field">
                    <div className="detail-field-label">Change ID</div>
                    <div className="detail-field-value">{change.id}</div>
                </div>
                <div className="detail-field">
                    <div className="detail-field-label">User ID</div>
                    <div className="detail-field-value">{change.user_id || '-'}</div>
                </div>
                <div className="detail-field">
                    <div className="detail-field-label">User Email</div>
                    <div className="detail-field-value">{change.user_email || '-'}</div>
                </div>
                <div className="detail-field">
                    <div className="detail-field-label">Change Type</div>
                    <div className="detail-field-value">{change.change_type || '-'}</div>
                </div>
                <div className="detail-field">
                    <div className="detail-field-label">Changed By Admin ID</div>
                    <div className="detail-field-value">{change.changed_by_admin_id || '-'}</div>
                </div>
                <div className="detail-field">
                    <div className="detail-field-label">Created At</div>
                    <div className="detail-field-value">{formatDate(change.created_at)}</div>
                </div>
                <div className="detail-field">
                    <div className="detail-field-label">Updated At</div>
                    <div className="detail-field-value">{formatDate(change.updated_at)}</div>
                </div>
                {change.deleted_at && (
                    <div className="detail-field">
                        <div className="detail-field-label">Deleted At</div>
                        <div className="detail-field-value">{formatDate(change.deleted_at)}</div>
                    </div>
                )}
            </div>

            <div className="detail-section">
                <h3>Changes</h3>
                {renderField('Fan Name', change.old_fan_name, change.new_fan_name)}
                {renderField('Fan Name Censored', change.old_fan_name_censored?.toString(), change.new_fan_name_censored?.toString())}
                {renderField('Email', change.old_email, change.new_email)}
                {renderField('First Name', change.old_first_name, change.new_first_name)}
                {renderField('Last Name', change.old_last_name, change.new_last_name)}
                {renderField('Street', change.old_street, change.new_street)}
                {renderField('ZIP', change.old_zip, change.new_zip)}
                {renderField('City', change.old_city, change.new_city)}
                {renderField('Country', change.old_country, change.new_country)}
                {renderField('Phone', change.old_phone, change.new_phone)}
                {renderField('Birthday', change.old_birthday, change.new_birthday)}
                {renderField('Gender', change.old_gender, change.new_gender)}
                {renderField('Avatar', change.old_avatar, change.new_avatar)}
                {renderField('Favourite Player ID', change.old_favourite_player_id?.toString(), change.new_favourite_player_id?.toString())}
                {renderField('Accept Marketing', change.old_accept_marketing?.toString(), change.new_accept_marketing?.toString())}
                {renderField('On Waiting List', change.old_on_waiting_list?.toString(), change.new_on_waiting_list?.toString())}
                {change.password_changed && (
                    <div className="detail-field">
                        <div className="detail-field-label">Password</div>
                        <div className="detail-field-value">Changed</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default observer(UserChangeDetail);
